import React, { useState, useEffect } from 'react';
import { client } from 'cccisd-apollo';
import Loader from 'cccisd-loader';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';
import { useParams, Redirect, useLocation, useHistory } from 'cccisd-react-router';
import query from './deployment.graphql';

const Fortress = window.cccisd.fortress;

const TakeAssessment = () => {
    const params = useParams();
    const location = useLocation();
    const history = useHistory();

    if (
        !params ||
        !params?.deploymentId ||
        !params?.deploymentHash ||
        Number.isNaN(parseInt(params.deploymentId, 10))
    ) {
        console.error('Incorrect route structure. Missing either deploymentId or deploymentHash');
        return <Redirect to="/" />;
    }

    const { deploymentId, deploymentHash } = params;
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const [metricsPawn, setMetricsPawn] = useState(null);

    useEffect(() => {
        async function getData() {
            const resp = await client.query({
                query,
                variables: {
                    deploymentId: parseInt(deploymentId, 10),
                    deploymentHash,
                },
                fetchPolicy: 'network-only',
            });

            const deploymentResp = resp.data.deployments.deployment;
            setData(deploymentResp);

            const mp = resp?.data?.groups?.tfhClass?.descendantRoles?.metricspawn?.pawn;
            setMetricsPawn(mp);
            setIsLoading(false);
        }

        getData();
    }, []);

    useEffect(() => {
        if (Fortress.auth() && location.search && location.search.includes('redirectUrl')) {
            history.replace(location.pathname);
        }
    }, [location]);

    if (isLoading || !data) {
        return <Loader loading />;
    }

    if (!data?.deploymentId) {
        return (
            <div className="alert alert-warning">
                <p className="mb-0">Could not find assessment. Please double check the provided URL.</p>
            </div>
        );
    }

    if (!data?.isOpen) {
        return (
            <div className="alert alert-info">
                <p className="mb-0">This assessment has been closed by administrators and is no longer available.</p>
            </div>
        );
    }

    if (!Fortress.auth()) {
        return <Redirect to={`/login?redirectUrl=${window.location.href}`} />;
    }

    /* Wait for useEffect to drop the search params, now that they are logged in */
    if (location.search && location.search.includes('redirectUrl')) {
        return <Loader loading />;
    }

    if (!['tfhChild', 'tfhParent'].includes(Fortress.user.acting.role.handle)) {
        return (
            <div className="alert alert-info">
                <p className="mb-0">This assessment is only for family members to complete.</p>
            </div>
        );
    }

    if (!metricsPawn?.pawnId || !metricsPawn?.pawnHash) {
        return (
            <div className="alert alert-danger">
                <p className="mb-0">Error: Could not find metrics pawn.</p>
            </div>
        );
    }

    return (
        <DeploymentPlayer
            deploymentId={deploymentId}
            deploymentHash={deploymentHash}
            pawnId={metricsPawn.pawnId}
            pawnHash={metricsPawn.pawnHash}
            flowProps={{
                variables: {
                    completedByStudyId: Fortress.user.acting?.role_data?.studyId,
                    completedByUsername: Fortress.user.acting.user.username,
                },
            }}
            disableLayout
        />
    );
};

export default TakeAssessment;
